import React from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import {
  Form,
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from '@/components/ui/form';
import {
  Card,
  CardHeader,
  CardContent,
  CardFooter,
} from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

const ManageAutorizedPersonsForm = () => {
  const history = useHistory();
  const { t } = useTranslation();

  const authorizedData = history.location.state?.data;

  const formSchema = z.object({
    authorizedPersons: z
      .string()
      .nonempty(t('validation.requiredField'))
      .regex(/^[A-Za-zĄČĘĖĮŠŲŪŽąčęėįšųūž, ]*$/i, 'Netinkamas vardo formatas'),
  });

  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      authorizedPersons: authorizedData?.value || '',
    },
  });

  const onSubmit = (data) => {
    history.push('/account/authorized-persons-confirmation', {
      data: {
        value: data.authorizedPersons,
        id: authorizedData.id,
        consentId: authorizedData.consentId,
      },
    });
  };

  return (
    <Card>
      <CardHeader className="flex items-center gap-2">
        <h2 className="text-xl font-semibold">
          {t('userAccount.authorizedPersonsEdit.authorizedPersonsTitle')}
        </h2>
      </CardHeader>

      <CardContent>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
            <FormField
              control={form.control}
              name="authorizedPersons"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>
                    {t('userAccount.authorizedPersonsEdit.authorizedPersons')}
                  </FormLabel>
                  <FormControl>
                    <Input {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </form>
        </Form>
      </CardContent>

      <CardFooter className="flex flex-col sm:flex-row sm:justify-end items-start gap-4">
        <Button
          type="button"
          variant="outline"
          onClick={() =>
            history.push('/useraccount/personal-info/manage-agreements')
          }
        >
          {t('userAccount.authorizedPersonsEdit.back')}
        </Button>
        <Button type="submit" onClick={form.handleSubmit(onSubmit)}>
          {t('userAccount.authorizedPersonsEdit.confirmData')}
        </Button>
      </CardFooter>
    </Card>
  );
};

export default ManageAutorizedPersonsForm;
